'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _currentUserActions = require('../../user/currentUserActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        initialiseCurrentUser: function initialiseCurrentUser() {
            return dispatch((0, _currentUserActions.fetchCurrentUser)());
        },
        setGuestUser: function setGuestUser(user) {
            return dispatch((0, _currentUserActions.setCurrentUserGuest)());
        }
    };
};

/**
 * This component is being used to separate the redirection logic out of the WorkspaceInitContainer to account
 * for the scenario that the root URL is loaded (e.g. www.milanote.com) because sub routes are not invoked in
 * this version of React Router when the current route matches exactly ('/').
 */

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var WorkspaceUserFetchDecorator = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(WorkspaceUserFetchDecorator, _React$Component);

        function WorkspaceUserFetchDecorator() {
            _classCallCheck(this, WorkspaceUserFetchDecorator);

            return _possibleConstructorReturn(this, (WorkspaceUserFetchDecorator.__proto__ || Object.getPrototypeOf(WorkspaceUserFetchDecorator)).apply(this, arguments));
        }

        _createClass(WorkspaceUserFetchDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _props = this.props,
                    initialiseCurrentUser = _props.initialiseCurrentUser,
                    isUserAvailable = _props.isUserAvailable,
                    isGuest = _props.isGuest,
                    setGuestUser = _props.setGuestUser;


                if (!isUserAvailable) initialiseCurrentUser();
                if (isGuest) setGuestUser();
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return WorkspaceUserFetchDecorator;
    }(_react2.default.Component)) || _class);


    WorkspaceUserFetchDecorator.propTypes = {
        isGuest: _propTypes2.default.bool,
        isUserAvailable: _propTypes2.default.bool,
        initialiseCurrentUser: _propTypes2.default.func,
        setGuestUser: _propTypes2.default.func
    };

    return WorkspaceUserFetchDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/workspaceUserFetchDecorator.js
// module id = 2158
// module chunks = 0